module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-compact-left-0f0311c0.svg";